import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';

import { DISPLAY_TYPE_TO_COMPONENT } from '../utils/displayTypeToComponent';
import { DISPLAY_TYPES } from '../utils/constants';

export default function CustomLinks({ sliceData }) {
  const displayType = get(sliceData, 'primary.display_type');
  const Component = DISPLAY_TYPE_TO_COMPONENT[displayType];

  return (
    <div className="PrismicCustomLinks">
      <Component
        headline={sliceData.primary.headline}
        items={sliceData.items}
      />
    </div>
  );
}

CustomLinks.propTypes = {
  sliceData: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.array,
    primary: PropTypes.shape({
      display_type: PropTypes.oneOf(Object.values(DISPLAY_TYPES)).isRequired,
      headline: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
